module.exports = __webpack_public_path__ + "img/image4.41d1104d.png";